import { useState } from 'react'
import { IconButton, Menu, MenuItem } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import useLogout from '../hooks/useLogout';

const UserMenu = () => {

	const [anchorEl, setAnchorEl] 	= useState(null)
	const [open, setOpen] 			= useState(false)

	const logout 					= useLogout()

	const handleOpen = (e) => {
		setAnchorEl(e.currentTarget)
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false);
	}

	const handleLogout = async () => {
		// Trigger para disparar evento de logout
		localStorage.setItem('logout', Date.now());		
		await logout()
	}
	
	return (
		<>
			<IconButton anchorel={anchorEl} onClick={handleOpen}>
				<AccountCircleIcon style={{ color: 'white' }}/>
			</IconButton>
			<Menu
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				>
				{/* <MenuItem component="a" href="/userdata"> Dados Pessoais </MenuItem> */}
				<MenuItem component="a" href="/subscription"> Assinatura </MenuItem>
				<MenuItem component="a" href="/user/settings"> Definições do Usuário </MenuItem>
				<MenuItem component="a" href="/changePassword"> Trocar Senha </MenuItem>
				<MenuItem onClick={handleLogout}> Logout </MenuItem>
			</Menu>
		</>
	)
}

export default UserMenu
